import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=0c9e3f5e&scoped=true"
import script from "./FileLoader.vue?vue&type=script&lang=js"
export * from "./FileLoader.vue?vue&type=script&lang=js"
import style0 from "./FileLoader.vue?vue&type=style&index=0&id=0c9e3f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e3f5e",
  null
  
)

export default component.exports